import axios from 'axios'
import { notify } from '@kyvg/vue3-notification';
import { formatDateTimeDMY } from '@/utils/date';
import useTags from '@/composables/useTags'

const ENDPOINT = '/v1/tags'
const { metadata } = useTags()

export default {

    namespaced: true,

    state: () => ({
        tags: [],
        tag: {},
        loading: false,
        formLoading: false,
    }),

    mutations: {
        SET_TAGS(state, payload) {
            state.tags = payload
        },

        SET_TAG(state, payload) {
            state.tag = payload
        },

        SET_LOADING(state, payload) {
            state.loading = payload
        },

        SET_FORMLOADING(state, payload) {
            state.formLoading = payload
        },
    },

    getters: {
        prepareTags(state) {
            return state.tags.map((tag) => ({
                id: tag.id,
                link: { name: `${metadata().routerPath}.show`, params: { id: tag.id } },
                title: tag.name || 'Sem nome',
                status: 'approved',
                bgColor: tag.colors.background,
                textColor: tag.colors.text,
                content_left: tag.description || 'Sem descrição',
                content_right_top: 'Data de criação',
                content_right_bottom: formatDateTimeDMY(tag.created_at),
            }))
        },

        prepareOptionsTags(state) {
            const optionsTags = state.tags.map((tag) => ({
                option: tag.id,
                description: tag.name
            }))

            optionsTags.unshift({ option: 'all', description: 'Todas as Tags' })

            return optionsTags;
        },
    },

    actions: {
        getTags({ commit }) {
            commit('SET_LOADING', true)

            axios.get(`${ENDPOINT}?type=${metadata().type}`)
                .then((response) => {
                    commit('SET_TAGS', response.data.data)
                })
                .catch((error) => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Oops',
                        text: 'ocorreu um erro ao buscar informações, tente novamente!',
                        duration: 2000,
                    })
                })
                .finally(() => commit('SET_LOADING', false))
        },

        getTag({ commit }, tagId) {
            parseInt(tagId)
            if (!tagId) return

            axios.get(`${ENDPOINT}/${tagId}`)
                .then((response) => {
                    commit('SET_TAG', response.data)
                })
                .catch(error => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Oops',
                        text: 'ocorreu um erro ao buscar informações, tente novamente!',
                        duration: 2000,
                    })
                })
        },

        updateTag({ state, commit, dispatch }) {
            axios.post(`${ENDPOINT}/update/${state.tag.id}`, state.tag)
                .then(() => {
                    notify({
                        type: 'success',
                        title: 'Uhuuuul!! 🥳',
                        text: 'Conforme solicitado, a informação foi editada com sucesso!',
                        duration: 2000,
                    })
                    commit('SET_TAG', {})
                    dispatch('getTags')
                })
                .catch(error => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Ooops...',
                        text: 'Ocorreu um erro ao processar a solicitação. Tente novamente mais tarde!',
                        duration: 2000,
                    })
                })
        },

        createTag({ dispatch }, payload) {
            axios.post(ENDPOINT, payload)
                .then(() => {
                    notify({
                        type: 'success',
                        title: 'Uhuuuul!!',
                        text: 'A tag foi cadastrada com sucesso!',
                    })

                    dispatch('getTags')
                })
                .catch(error => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Ooops...',
                        text: 'Ocorreu um erro ao processar a solicitação. Tente novamente mais tarde!',
                        duration: 2000,
                    })
                })
        },
        deleteTag({ commit, dispatch }, tagId) {
            commit('SET_FORMLOADING', true)
            axios.delete(`${ENDPOINT}/delete/${tagId}`)
                .then(() => {
                    notify({
                        type: 'success',
                        title: 'Uhuuuul!!',
                        text: 'Conforme solicitado, a informação foi deletada com sucesso!',
                        duration: 2000,
                    })

                })
                .catch(error => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Ooops...',
                        text: 'Ocorreu um erro ao processar a solicitação. Tente novamente mais tarde!',
                        duration: 2000,
                    })
                    commit('SET_FORMLOADING', false)
                })
                .finally(() => {
                    dispatch('getTags')
                    setTimeout(() => {
                        commit('SET_FORMLOADING', false)
                    }, 150)
                })
        },
    },
}
